import styled from 'styled-components';
import { SummaryLegalTextStyled } from '@components/SummaryLegalText/SummaryLegalTextStyled';

export const SummaryLegalTextStyledOV = styled(SummaryLegalTextStyled)`
    p {
        font-size: ${({ theme }) => theme.fontSizes.textSupBase} !important;
        color: ${({ theme }) => theme.colors.grey28};
    }
`;
